export default {
	namespaced: true,
	state: {
		isShowedSidebar: true,
	},

	mutations:{
		setIsShowedSidebar(state, payload){
			state.isShowedSidebar=payload
		},
	},
	getters:{
		getIsShowedSidebar(state) {
			return state.isShowedSidebar
		}
	},
	actions: {
		/**
		 * [getFile description]
		 * @return {[type]} [description]
		 */
		getFile({commit, getters}, url) {
			return this._vm.$http.post('/file', {url, url}, {responseType: 'blob'})
				.then(response => {
					// console.log(response)
					return response.blob()
				})
		},

		toggleSidebar({state, commit, dispatch}) {
			commit('setIsShowedSidebar', !state.isShowedSidebar)
		}
	},

}